module.exports = __webpack_public_path__ + "static/media/CharlesJackson-resume.4e0cca87.pdf";